import { useAppDispatch, useAppSelector } from 'appState/store'
import { Layout } from 'components/Layout'
import { getBatchResults } from 'features/autocheck/autoCheckApi'
import { updateAllClaimsRoute } from 'features/claims/claimsSlice'
import { ClaimsTable } from 'features/claims/components/ClaimsTable/ClaimsTable'
import { AllClaims } from 'pages/AllClaims'
import { ClaimCalls, ClaimCallsSummary, ClaimDetailsPage } from 'pages/Claims'
import { PathsEnum } from 'pages/Paths'
import { Navigate, Route, Routes } from 'react-router-dom'

// paths
// components
// features
const ClaimsRouter = () => {
  const dispatch = useAppDispatch()

  const { batchId, batchCode } = useAppSelector((state) => state.claims.allClaimRouteUrl)

  if (batchId && !batchCode) {
    getBatchResults(batchId).then((batchResult) => {
      if (batchResult) {
        dispatch(
          updateAllClaimsRoute({
            batchId: batchResult.batchId,
            batchCode: batchResult.batchCode,
          }),
        )
      }
    })
  }

  return (
    <Layout>
      <Routes>
        {/* valid routes */}
        <Route path={PathsEnum.root} element={<AllClaims />}>
          <Route path={PathsEnum.root} element={<ClaimsTable />} />
          <Route path={PathsEnum.claimsBatch} element={<ClaimsTable />} />
        </Route>

        {/* Claim detail routes - support both with and without batch */}
        <Route path={PathsEnum.claimDetails} element={<ClaimDetailsPage />} />
        <Route path={`${PathsEnum.claimBatch}/:batchId/${PathsEnum.claimDetails}`} element={<ClaimDetailsPage />} />

        {/* Call routes - support both with and without batch */}
        <Route path={`${PathsEnum.claim}/:oaiClaimId/${PathsEnum.call}/:callId`} element={<ClaimCalls />} />
        <Route
          path={`${PathsEnum.claimBatch}/:batchId/${PathsEnum.claim}/:oaiClaimId/${PathsEnum.call}/:callId`}
          element={<ClaimCalls />}
        />

        {/* Call summary routes - support both with and without batch */}
        <Route
          path={`${PathsEnum.claim}/:oaiClaimId/${PathsEnum.callsSummary}/:callId`}
          element={<ClaimCallsSummary />}
        />
        <Route
          path={`${PathsEnum.claimBatch}/:batchId/${PathsEnum.claim}/:oaiClaimId/${PathsEnum.callsSummary}/:callId`}
          element={<ClaimCallsSummary />}
        />

        {/* redirect to work queue page if invalid route */}
        <Route path={PathsEnum.other} element={<Navigate replace to={PathsEnum.root} />} />
      </Routes>
    </Layout>
  )
}

export { ClaimsRouter }
